import React from "react";
import { LogoMark } from "../../components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex bg-[#F4F7FA]">
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-[#081A33]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-50"
          style={{ backgroundImage: "url('https://images.pexels.com/photos/32476095/pexels-photo-32476095.jpeg')" }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#081A33] via-[#0F2746]/80 to-transparent" />
        <div className="relative p-12 flex flex-col justify-between w-full text-[#F3F5F8]">
          <div className="flex items-center gap-3">
            <LogoMark className="w-10 h-10" color="#F3F5F8" />
            <div className="font-serif-ap text-2xl">Alaca Partners</div>
          </div>
          <div>
            <div className="overline text-[#C4A47C]">Yönetim Paneli</div>
            <div className="font-serif-ap text-5xl mt-4 leading-tight">Boğaz'ın iki yakasında, hukuki sezginin merkezinde.</div>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="overline text-[#4A6A8F]">Giriş</div>
          <h1 className="font-serif-ap text-4xl text-[#0F2746] mt-4">Yönetim paneline hoş geldiniz</h1>
          <p className="text-[#3A5170] mt-6 text-sm leading-relaxed">
            Bu panel yalnızca yetkili e-posta sahipleri içindir. Devam etmek için Google hesabınızla giriş yapın.
          </p>
          <button
            data-testid="google-login-btn"
            onClick={handleLogin}
            className="mt-10 w-full bg-[#0F2746] text-[#F3F5F8] hover:bg-[#081A33] py-4 text-sm uppercase tracking-[0.2em] font-semibold transition-colors flex items-center justify-center gap-3"
          >
            <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.4 29.3 35.5 24 35.5c-6.4 0-11.5-5.1-11.5-11.5S17.6 12.5 24 12.5c2.9 0 5.6 1.1 7.6 2.9l5.7-5.7C33.6 6.3 29 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.3-.3-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.6 19 12.5 24 12.5c2.9 0 5.6 1.1 7.6 2.9l5.7-5.7C33.6 6.3 29 4.5 24 4.5 16.6 4.5 10.2 8.5 6.3 14.7z"/><path fill="#4CAF50" d="M24 43.5c5 0 9.5-1.7 13-4.6l-6-5.1c-1.9 1.4-4.3 2.2-7 2.2-5.3 0-9.7-3.1-11.3-7.5l-6.5 5C9.9 39.4 16.4 43.5 24 43.5z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.4l6 5.1C41 35.7 43.5 30.3 43.5 24c0-1.2-.1-2.3-.3-3.5z"/></svg>
            Google ile Giriş Yap
          </button>
          <p className="text-xs text-[#4A6A8F] mt-8 text-center tracking-wide">
            Yetkili e-posta: alacapartners@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
}
